import React, { memo } from "react";

const DashboardHeader = ({
  userName,
  roleBadge,
  subtitle,
  className = "",
  role = "",
}) => {
  const displayName = userName?.split(" ")[0] || userName || "User";
  const greeting = `Welcome back, ${displayName}`;
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="flex flex-wrap items-center gap-2">
        <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">{greeting}</h1>
        {roleBadge && (
          <span className="text-xs font-medium text-secondary bg-secondary-transparent px-2.5 py-1 rounded-md">
            {roleBadge}
          </span>
        )}
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-1 text-[0.85rem] text-gray-500 dark:text-gray-400">
        {role === "org_admin" ||
          (role === "superadmin" && (
            <>
              <span>{today}</span> <span className="text-gray-500 dark:text-gray-600">|</span>
            </>
          ))}
        {subtitle && <span>{subtitle}</span>}
      </div>
    </div>
  );
};

export default memo(DashboardHeader);
